import { all, takeLatest, put, call } from 'redux-saga/effects';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  VERIFY_REQUEST,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  VERIFY_ERROR,
  VERIFY_SUCCESS,
  GET_USER_REQUEST,
  GET_USER_ERROR,
  GET_USER_SUCCESS,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  GET_PROFILE_QUESTION_REQUEST,
  GET_PROFILE_QUESTION_SUCCESS,
  GET_PROFILE_QUESTION_ERROR,
  ANSWER_REQUEST,
  ANSWER_SUCCESS,
  ANSWER_ERROR,
} from '../reducers/AuthReducer';

import { getSimplifiedError } from '../../utils/error';
import { request, setupHttpConfig } from '../../utils/http';

function login(payload) {
  return request.post('/token', payload);
}

export function* handleLogin({ payload }) {
  try {
    const { data } = yield call(login, payload);
    localStorage.setItem('access', data.access);
    localStorage.setItem('refresh', data.refresh);
    setupHttpConfig();
    yield call(handleGetUser);
    yield put({
      type: LOGIN_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: LOGIN_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function verify(payload) {
  return request.post('/password-reset/confirm/', payload);
}

function* handleVerify({ payload }) {
  try {
    yield call(verify, payload);
    yield put({
      type: VERIFY_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: VERIFY_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function resetPassword(payload) {
  return request.post('/password-reset/', payload);
}

function* handleResetPassword({ payload }) {
  try {
    yield call(resetPassword, payload);

    yield put({
      type: RESET_PASSWORD_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: RESET_PASSWORD_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getUser() {
  return request.get('/me');
}

function* handleGetUser() {
  try {
    const { data } = yield call(getUser);
    yield put({
      type: GET_USER_SUCCESS,
      info: data,
    });
  } catch (error) {
    yield put({
      type: GET_USER_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function updateUser(payload) {
  return request.put('/me/update/', payload);
}

function* handleUpdateUser({ payload }) {
  try {
    const { data } = yield call(updateUser, payload);
    yield put({
      type: UPDATE_USER_SUCCESS,
      info: data,
    });
  } catch (error) {
    yield put({
      type: UPDATE_USER_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getProfileQuestion() {
  return request.get('/survey/get-profile-questions/');
}

function* handleGetProfileQuestion() {
  try {
    const { data } = yield call(getProfileQuestion);
    yield put({
      type: GET_PROFILE_QUESTION_SUCCESS,
      info: data,
    });
  } catch (error) {
    yield put({
      type: GET_PROFILE_QUESTION_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function answerProfileQuestion(payload) {
  return request.post('/survey/answer-profile-questions/', payload);
}

function* handleAnswerProfileQuestion({ payload }) {
  try {
    const { data } = yield call(answerProfileQuestion, payload);
    yield put({
      type: ANSWER_SUCCESS,
      info: data,
    });
  } catch (error) {
    yield put({
      type: ANSWER_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

export default all([
  takeLatest(LOGIN_REQUEST, handleLogin),
  takeLatest(VERIFY_REQUEST, handleVerify),
  takeLatest(RESET_PASSWORD_REQUEST, handleResetPassword),
  takeLatest(GET_USER_REQUEST, handleGetUser),
  takeLatest(UPDATE_USER_REQUEST, handleUpdateUser),
  takeLatest(GET_PROFILE_QUESTION_REQUEST, handleGetProfileQuestion),
  takeLatest(ANSWER_REQUEST, handleAnswerProfileQuestion),
]);
